import React, { useState } from 'react';
import useFadeIn from '../hooks/useFadeIn';
import { useLang } from '../LanguageContext';
import './Contact.css';

const T = {
  heading: { ko: '문의하기', en: 'Contact' },
  desc:    { ko: '제품 도입 및 기타 문의사항을 남겨주세요', en: 'Leave us a message about product adoption or any other inquiry.' },
  info: {
    address: { ko: '주소', en: 'Address' },
    addressVal: { ko: '(15324) 경기도 안산시 상록구 안산대학로 117, 201호',
                  en: '117 Ansandaehak-ro, Sangnok-gu, Ansan-si, Gyeonggi-do 15324, South Korea (Suite 201)' },
    phone:   { ko: '전화', en: 'Phone' },
    email:   { ko: '이메일', en: 'Email' },
    hours:   { ko: '업무 시간', en: 'Business Hours' },
    hoursVal:{ ko: '평일 09:00 - 18:00', en: 'Weekdays 09:00 – 18:00 (KST)' },
    youtube: { ko: '유튜브', en: 'YouTube' },
    youtubeLabel: { ko: '메디로지스TV', en: 'MEDILOGIS TV' },
  },
  form: {
    name: { ko: '이름 / 기관명', en: 'Name / Organization' },
    namePh: { ko: '홍길동 / OO요양원', en: 'John Doe / Care Facility' },
    email: { ko: '이메일', en: 'Email' },
    phone: { ko: '연락처', en: 'Phone' },
    subject: { ko: '문의 유형', en: 'Inquiry Type' },
    selectPlaceholder: { ko: '선택해주세요', en: 'Please select' },
    options: {
      product:     { ko: '제품 문의',         en: 'Product inquiry' },
      pricing:     { ko: '가격/도입 문의',    en: 'Pricing / Adoption' },
      demo:        { ko: '데모 요청',         en: 'Demo request' },
      partnership: { ko: '제휴/협력',         en: 'Partnership' },
      other:       { ko: '기타',              en: 'Other' },
    },
    message: { ko: '문의 내용', en: 'Message' },
    messagePh: { ko: '문의하실 내용을 입력해주세요', en: 'Please enter your message' },
    submit: { ko: '문의 보내기', en: 'Send Inquiry' },
    success: { ko: '문의가 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.', en: 'Your inquiry has been received. We will reply shortly.' },
    fail: { ko: '문의 접수에 실패했습니다. 다시 시도해주세요.', en: 'Failed to submit inquiry. Please try again.' },
    err: { ko: '서버 연결에 실패했습니다', en: 'Server connection failed' },
  },
};

function Contact() {
  const ref = useFadeIn();
  const { lang } = useLang();
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('/api/inquiry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          alert(T.form.success[lang]);
          setForm({ name: '', email: '', phone: '', subject: '', message: '' });
        } else {
          alert(T.form.fail[lang]);
        }
      })
      .catch((err) => alert(T.form.err[lang] + ': ' + err.message));
  };

  return (
    <section className="section contact">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">CONTACT</span>
          <h2>{T.heading[lang]}</h2>
          <p className="section-desc">{T.desc[lang]}</p>
        </div>
        <div className="contact-grid" ref={ref}>
          <div className="contact-info">
            <div className="contact-item">
              <h4>{T.info.address[lang]}</h4>
              <p>{T.info.addressVal[lang]}</p>
            </div>
            <div className="contact-item">
              <h4>{T.info.phone[lang]}</h4>
              <p>031-8042-7660</p>
            </div>
            <div className="contact-item">
              <h4>{T.info.email[lang]}</h4>
              <p>medilogis@medilogis.net</p>
            </div>
            <div className="contact-item">
              <h4>{T.info.hours[lang]}</h4>
              <p>{T.info.hoursVal[lang]}</p>
            </div>
            <div className="contact-item">
              <h4>{T.info.youtube[lang]}</h4>
              <p><a href="https://www.youtube.com/@medilogisTV" target="_blank" rel="noopener noreferrer" style={{color:'var(--primary)'}}>{T.info.youtubeLabel[lang]}</a></p>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">{T.form.name[lang]}</label>
                <input type="text" id="name" name="name" value={form.name} onChange={handleChange} required placeholder={T.form.namePh[lang]} />
              </div>
              <div className="form-group">
                <label htmlFor="email">{T.form.email[lang]}</label>
                <input type="email" id="email" name="email" value={form.email} onChange={handleChange} required placeholder="example@email.com" />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="phone">{T.form.phone[lang]}</label>
              <input type="tel" id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="010-0000-0000" />
            </div>
            <div className="form-group">
              <label htmlFor="subject">{T.form.subject[lang]}</label>
              <select id="subject" name="subject" value={form.subject} onChange={handleChange}>
                <option value="">{T.form.selectPlaceholder[lang]}</option>
                <option value="product">{T.form.options.product[lang]}</option>
                <option value="pricing">{T.form.options.pricing[lang]}</option>
                <option value="demo">{T.form.options.demo[lang]}</option>
                <option value="partnership">{T.form.options.partnership[lang]}</option>
                <option value="other">{T.form.options.other[lang]}</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">{T.form.message[lang]}</label>
              <textarea id="message" name="message" rows="5" value={form.message} onChange={handleChange} required placeholder={T.form.messagePh[lang]}></textarea>
            </div>
            <button type="submit" className="btn-submit">{T.form.submit[lang]}</button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
